import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import './LanguageToggle.scss';

const LanguageToggle = () => {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const switchTo = (targetLang) => {
    if (targetLang === lang) return;
    const newPath = location.pathname.replace(`/${lang}`, `/${targetLang}`);
    navigate(newPath + location.search);
  };

  return (
    <div className="lang-toggle" role="radiogroup" aria-label="Language">
      <button
        className={`lang-toggle__option ${lang === 'es' ? 'lang-toggle__option--active' : ''}`}
        onClick={() => switchTo('es')}
        aria-checked={lang === 'es'}
        role="radio"
        lang="es"
      >
        ES
      </button>
      <button
        className={`lang-toggle__option ${lang === 'en' ? 'lang-toggle__option--active' : ''}`}
        onClick={() => switchTo('en')}
        aria-checked={lang === 'en'}
        role="radio"
        lang="en"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
